"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_EMAIL_SENDING_DOMAIN = exports.NEWFORM_EMAIL_DOMAIN = exports.LEGACY_NEWFORM_EMAIL_DOMAIN = void 0;
exports.isNewformEmail = isNewformEmail;
exports.emailSendingDomain = emailSendingDomain;
exports.LEGACY_NEWFORM_EMAIL_DOMAIN = "newform.ai";
exports.NEWFORM_EMAIL_DOMAIN = "newform.com";
/**
 * Whether the email belongs to a Newform employee. Accepts both domains:
 * the account-link migration (#1390) moves users from @newform.ai to
 * @newform.com one PIN confirmation at a time, so both populations coexist
 * indefinitely. Feature gates must use this rather than hardcoding either
 * domain — hardcoding silently locks out half the team.
 */
function isNewformEmail(email) {
    if (!email)
        return false;
    const normalized = email.trim().toLowerCase();
    return (normalized.endsWith(`@${exports.NEWFORM_EMAIL_DOMAIN}`) ||
        normalized.endsWith(`@${exports.LEGACY_NEWFORM_EMAIL_DOMAIN}`));
}
exports.DEFAULT_EMAIL_SENDING_DOMAIN = "updates.newform.ai";
/**
 * Resend sending domain for transactional mail, shared by the backend and
 * Reporting Lab because both build their own Resend clients. Configurable so
 * the domain can be swapped without a deploy if deliverability degrades.
 *
 * Must name a domain verified in Resend — an unverified one makes Resend
 * reject every send outright. Verified today: updates.newform.ai,
 * notifications.newform.ai, updates.newform.com, notifications.newform.com.
 *
 * Trimmed because this is set by hand in the hosting platform, where a trailing space
 * would otherwise produce a malformed From address.
 */
function emailSendingDomain() {
    var _a;
    return (((_a = process.env.EMAIL_SENDING_DOMAIN) === null || _a === void 0 ? void 0 : _a.trim()) || exports.DEFAULT_EMAIL_SENDING_DOMAIN);
}
